/**
 * Последняя открытая доска — общая и в каждом подразделении.
 *
 * §3.5 разрешает хранить это локально: выбранная доска — пользовательская
 * настройка, а не сущность. Сущности, права и справочники живут только
 * на сервере.
 *
 * §8.5: выбор сохраняется между переходами. Вкладка подразделения ведёт
 * на доску, открытую в нём последней, а не всегда на первую.
 *
 * Вынесено из BoardsPage.tsx: файл, экспортирующий и компоненты, и функции,
 * ломает fast refresh в разработке.
 */

const LAST_BOARD_KEY = "tf.lastBoardId";

function departmentKey(departmentCode: string): string {
  return `${LAST_BOARD_KEY}.${departmentCode}`;
}

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    // Приватный режим — просто откроется первая доска.
    return null;
  }
}

export function readLastBoardId(): string | null {
  return read(LAST_BOARD_KEY);
}

export function rememberBoardId(boardId: string, departmentCode?: string): void {
  try {
    localStorage.setItem(LAST_BOARD_KEY, boardId);
    if (departmentCode !== undefined && departmentCode !== "") {
      localStorage.setItem(departmentKey(departmentCode), boardId);
    }
  } catch {
    // Настройка не сохранится между сессиями — допустимая деградация.
  }
}

/**
 * Доска для вкладки подразделения: открытая в нём последней, если доступ
 * к ней остался, иначе первая. null — в подразделении досок нет.
 */
export function pickBoardFor(
  departmentCode: string,
  boards: readonly { id: string; departmentCode: string }[],
): string | null {
  const inDepartment = boards.filter((board) => board.departmentCode === departmentCode);
  const remembered = read(departmentKey(departmentCode));
  return (inDepartment.find((board) => board.id === remembered) ?? inDepartment[0])?.id ?? null;
}
